import template from './cjenik.html';
import ListController from '../common/list.controller.js';

class CjenikController extends ListController {
    constructor(DS, $q, $uibModal, AppConfiguration, logger) {
        super(DS.definitions.Cjenik);
        this.DS = DS;
        this.$q = $q;
        this.logger = logger;
        this.view = AppConfiguration().getViewByEntityAndType('Cjenik', 'ListView');
        this.formView = AppConfiguration().getViewByEntityAndType('Cjenik', 'EditView');
        this.$uibModal = $uibModal;

        this.icon = this.view.icon();
        this.pageTitle = this.view.title();
        this.pageDesc =this.view.description();

        this.getState();
    }

    getState() {
        this.DS.findAll('Valuta')
            .then((response) => {
                this.valute = response;
            })
            .finally(() => {
                this.getItems();
            });
    }

    getQueryset(params) {
        return this.Model.findAll(params, {bypassCache: true});
    }

    edit(item) {
        const modal = this.showForm(item);
        modal.result.then((model) => {
            this.Model.update(model.id, model)
                .then(() => this.getState())
                .catch((error) => {
                    this.logger.error('Upsss', error.data);
                });
            });
    }

    insert() {
        const modal = this.showForm({});
        modal.result.then((model) => {
            this.Model.create(model)
                .then(() => this.getState())
                .catch((error) => {
                    this.logger.error('Upsss', error.data);
                });
            });
    }

    showForm(item) {
        const view = this.formView;
        const modal = this.$uibModal.open({
            component: 'modalForm',
            size: 'lg',
            resolve: {
                item: function() {
                    return item;
                },
                view: function() {
                    return view;
                },
            },
        });
        return modal;
    }


}

CjenikController.$inject = ['DS', '$q', '$uibModal', 'AppConfiguration', 'logger'];

const CjenikComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: CjenikController,
    controllerAs: 'vm'
};

export {CjenikComponent};



// WEBPACK FOOTER //
// ./app/components/cjenik/cjenik.component.js